<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781466817081_toc01#toctitle15" id="title15"><span><strong class="b">PART III</strong></span></a></div>
<div class="illustype_fullpage_image"><div class="caption"><div class="p"><span><em class="i">Khatchkar</em> at Etchmiadzin</span></div></div>
<div class="fullpage_image"><img alt="e9781466817081_i0005.jpg" src="e9781466817081_i0005.jpg"/></div>
<a id="page_82"></a></div><a id="page_82">
</a><a id="page_83">
</a></div><a id="page_83">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466817081_p03.vue?e8c62404